import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './app/App.vue';

const pinia = createPinia();

const app = createApp(App).use(pinia);

app.mount("#js-productDocumentationApp");